/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IOasHeaderParent } from '../../models/IOasHeaderParent';
import { OasHeader } from '../../models/OasHeader';
import { OasResponse } from '../../models/OasResponse';
import { IOas30MediaTypeParent } from './IOas30MediaTypeParent';
import { Oas30Header } from './Oas30Header';
import { Oas30MediaType } from './Oas30MediaType';
import { Oas30Link } from './Oas30Link';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} statusCode
 * @class
 * @extends OasResponse
 * @author eric.wittmann@gmail.com
 */
export class Oas30Response extends OasResponse implements IOas30MediaTypeParent, IOasHeaderParent {
    public headers : any = <any>({});

    public content : any = <any>({});

    public links : any = <any>({});

    public constructor(statusCode : string) {
        super(statusCode);
    }

    /**
     * Gets the status code.
     * @return {string}
     */
    public getStatusCode() : string {
        return this.getName();
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#createMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public createMediaType(name : string) : Oas30MediaType {
        let rval : Oas30MediaType = new Oas30MediaType(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#addMediaType(java.lang.String, io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {string} name
     * @param {Oas30MediaType} mediaType
     */
    public addMediaType(name : string, mediaType : Oas30MediaType) {
        /* put */(this.content[name] = mediaType);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public getMediaType(name : string) : Oas30MediaType {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.content, name);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#removeMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public removeMediaType(name : string) : Oas30MediaType {
        return /* remove */(map => { let deleted = this.content[name];delete this.content[name];return deleted;})(this.content);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaTypes()
     * @return {Oas30MediaType[]}
     */
    public getMediaTypes() : Array<Oas30MediaType> {
        let rval : Array<Oas30MediaType> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.content));
        return rval;
    }

    /**
     * Creates a link.
     * @param {string} name
     * @return {Oas30Link}
     */
    public createLink(name : string) : Oas30Link {
        let rval : Oas30Link = new Oas30Link(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a link.
     * @param {string} name
     * @param {Oas30Link} link
     */
    public addLink(name : string, link : Oas30Link) {
        /* put */(this.links[name] = link);
    }

    /**
     * Gets a single link by name.
     * @param {string} name
     * @return {Oas30Link}
     */
    public getLink(name : string) : Oas30Link {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.links, name);
    }

    /**
     * Removes a single link and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30Link}
     */
    public removeLink(name : string) : Oas30Link {
        return /* remove */(map => { let deleted = this.links[name];delete this.links[name];return deleted;})(this.links);
    }

    /**
     * Gets a list of all links.
     * @return {Oas30Link[]}
     */
    public getLinks() : Array<Oas30Link> {
        let rval : Array<Oas30Link> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.links));
        return rval;
    }

    /**
     * Creates a http header.
     * @param {string} name
     * @return {Oas30Header}
     */
    public createHeader(name : string) : Oas30Header {
        let rval : Oas30Header = new Oas30Header(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a header.
     * @param {string} name
     * @param {OasHeader} header
     */
    public addHeader(name : string, header : OasHeader) {
        /* put */(this.headers[name] = <Oas30Header>header);
    }

    /**
     * Gets a single header by name.
     * @param {string} name
     * @return {OasHeader}
     */
    public getHeader(name : string) : OasHeader {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.headers, name);
    }

    /**
     * Removes a single header and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {OasHeader}
     */
    public removeHeader(name : string) : OasHeader {
        return /* remove */(map => { let deleted = this.headers[name];delete this.headers[name];return deleted;})(this.headers);
    }

    /**
     * Gets a list of all headers.
     * @return
     * @return {OasHeader[]}
     */
    public getHeaders() : Array<OasHeader> {
        let rval : Array<OasHeader> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.headers));
        return rval;
    }
}
Oas30Response["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Response";
Oas30Response["__interfaces"] = ["io.apicurio.datamodels.openapi.models.IOasHeaderParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent","io.apicurio.datamodels.core.models.common.INamed"];




